import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useListaCEPService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon

export const RecorteListaCEP = () => {
    // Redux State
    const { listasCEP } = useAppSelector((state) => state.listaCEP)
    const { openForm, editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedListaCEP, setSelectedListaCEP] = useState<number[]>([])

    // Hooks
    const { setupListaCEP, resetListasCEP } = useListaCEPService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        setupListaCEP()
    }, [setupListaCEP])

    useEffect(() => {
        resetListasCEP()
    }, [openForm, resetListasCEP])

    useEffect(() => {
        const listasCEPSelecionadas = editRecorteExtracaoForm.fields.Filtros?.listasCEP || [];

        if (listasCEPSelecionadas.length > 0) {
            setSelectedListaCEP(listasCEPSelecionadas);
        } else {
            setSelectedListaCEP([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.listasCEP]);

    const filteredListasCEP = (listasCEP || []).filter((lista) =>
        !selectedListaCEP.includes(lista?.IdVelesGeoListaCEP || 0)
    );

    const handleListaCEPSelectionChange = (value: any[]) => {
        const ids = (value || []).map((lista) => lista?.IdVelesGeoListaCEP || 0)
        setSelectedListaCEP(ids);

        if (ids.length > 0) {
            syncFilterWithForm({
                filtro: 'listasCEP',
                value: ids,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'listasCEP',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredListasCEP}
                    value={(listasCEP || []).filter(lista =>
                        selectedListaCEP.includes(lista?.IdVelesGeoListaCEP || 0)
                    )}
                    getOptionLabel={(option) => option?.Nome?.toUpperCase() || ''}
                    sx={{ px: 2 }}
                    onChange={(event, value) => {
                        handleListaCEPSelectionChange(value);
                    }}
                    noOptionsText={'Nenhuma lista encontrada'}
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Listas de CEPs"
                        />
                    )}
                />
            </Grid>
        </>
    )
}